<template>
  <div class="highlight">
    <div class="highlight-inner">
      <div class="highlight-label">
        <span class="spark" aria-hidden="true">✦</span>
        Diferencial competitivo
      </div>

      <h2 class="highlight-title">
        SUPORTE RÁPIDO E EFICIENTE
      </h2>

      <p class="highlight-subtitle">
        Quando você implanta o EasySaúde, você não fica sozinho. A prioridade é destravar o seu fluxo para o time
        operar com confiança, inclusive em dias cheios.
      </p>

      <div class="highlights">
        <div class="h-item">
          <div class="h-num">1</div>
          <div>
            <div class="h-title">Respostas claras</div>
            <div class="h-text">Orientação direta para o seu time executar sem retrabalho.</div>
          </div>
        </div>
        <div class="h-item">
          <div class="h-num">2</div>
          <div>
            <div class="h-title">Acompanhamento na implantação</div>
            <div class="h-text">Ajustes para a realidade da sua clínica funcionar de verdade.</div>
          </div>
        </div>
        <div class="h-item">
          <div class="h-num">3</div>
          <div>
            <div class="h-title">Continuidade</div>
            <div class="h-text">Você evolui o sistema sem “paradas” no meio do cuidado.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'CompetitiveSection' }
</script>

<style scoped>
.highlight {
  background: linear-gradient(135deg, rgba(77, 186, 135, 0.18), rgba(77, 186, 135, 0.06) 45%, rgba(15, 23, 42, 0) 80%);
  border: 1px solid rgba(77, 186, 135, 0.20);
  border-radius: 18px;
  overflow: hidden;
}

.highlight-inner {
  padding: 28px 22px;
}

.highlight-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(77, 186, 135, 0.10);
  border: 1px solid rgba(77, 186, 135, 0.22);
  font-weight: 900;
}

.spark {
  width: 26px;
  height: 26px;
  border-radius: 10px;
  background: rgba(77, 186, 135, 0.18);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.highlight-title {
  margin: 16px 0 12px;
  font-size: 44px;
  line-height: 1.05;
  letter-spacing: -0.03em;
}

.highlight-subtitle {
  margin: 0;
  color: var(--easy-muted);
  line-height: 1.6;
  font-size: 16px;
  max-width: 78ch;
}

.highlights {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-top: 18px;
}

.h-item {
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid var(--easy-border);
  border-radius: 16px;
  padding: 16px;
}

.h-num {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: rgba(77, 186, 135, 0.14);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  margin-bottom: 10px;
}

.h-title {
  font-weight: 900;
}

.h-text {
  margin-top: 6px;
  color: var(--easy-muted);
  line-height: 1.55;
  font-size: 14px;
}

@media (max-width: 980px) {
  .highlight-title {
    font-size: 34px;
  }
  .highlights {
    grid-template-columns: 1fr;
  }
}
</style>
